module.exports = __webpack_public_path__ + "files/112b01865f9e89fcf1a1fa0998acffb8.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/flags-4.png
// module id = 1486
// module chunks = 60